module.exports = __webpack_public_path__ + "img/bulb.a2708717.svg";